<template>
  <div class="list-item">
    <div v-for="(item, index) in videoList" :key="index" class="item" @click="jumpDetail(item)">
      <div class="content">
        <video :ref="'video' + index" :poster="item.posterDataUrl" height="400" :autoplay='false' :src="item.attachment"
          @loadeddata="captureFrame(index)" controls class="video" crossorigin="anonymous" />
      </div>
      <span class="title">{{ item.title }}</span>
    </div>
    <!-- 无数据 -->
    <div v-if="videoList.length === 0" class="no-data">
      <span>暂无数据</span>
    </div>

  </div>
</template>

<script>
import { get } from "@/request/http";
import { sanitizeVideoList } from "@/utils/urlValidator";
export default {
  data() {
    return {
      videoList: [],
    };
  },
  created() {
    this.fetchVideoList();
  },

  methods: {
    captureFrame(index) {
      // 获取视频元素，考虑$refs可能返回数组的情况
      let videoRef = this.$refs['video' + index];
      // 检查是否为数组，如果是数组则取第一个元素
      let video = Array.isArray(videoRef) ? videoRef[0] : videoRef;
      
      // 确保video元素存在且是DOM元素
      if (!video || typeof video.addEventListener !== 'function') {
        console.warn('视频元素不可用或不是DOM元素', index);
        return;
      }
      
      video.currentTime = 1; 
      
      // 使用命名函数替代匿名函数，以便能够显式移除事件监听器
      const handleSeeked = () => {
        // 显式移除事件监听器，防止内存泄漏
        video.removeEventListener('seeked', handleSeeked);
        
        const canvas = document.createElement('canvas');
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        const context = canvas.getContext('2d');
        context.drawImage(video, 0, 0, canvas.width, canvas.height);
        const dataUrl = canvas.toDataURL('image/png');
        this.$set(this.videoList[index], 'posterDataUrl', dataUrl);
      };
      
      // 添加事件监听器，并保留once: true作为额外保障
      video.addEventListener('seeked', handleSeeked, { once: true });
    },
    // 获取视频列表
    fetchVideoList() {
      get('/gbs/portal/portal/newsPage?limit=100&page=1&categoryId=504&title=').then(res => {
        if (res.code !== 0) {
          this.$Toast && this.$Toast.fail(res.msg);
          return;
        }
        // 对获取到的视频列表进行安全验证处理
        this.videoList = sanitizeVideoList(res.data.list || [], 'attachment', '');
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.list-item {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  .item {
    width: 100%;
    height: 440px;
    font-size: 28px;
    font-family: Source Han Sans SC VF, Source Han Sans SC VF;
    font-weight: 500;
    color: #333333;
    display: flex;
    align-items: center;
    flex-direction: column;
    margin: 20px;

    .content {
      width: 100%;
      display: flex;
      align-items: center;
      overflow: hidden;
    }

    .video {
      width: 100%;
      height: 400px;
      object-fit: cover;
    }

    .title {
      width: 100%;
      height: 32px;
      overflow: hidden;
      text-align: left;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .item:last-child {
    margin-bottom: 40px;
  }

  .no-data {
    width: 100%;
    height: 60px;
    font-size: 24px;
    font-family: Source Han Sans SC VF, Source Han Sans SC VF;
    font-weight: 500;
    color: #333333;
    line-height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>